// Hardcoded fallback reason list, used only if GET /api/cancellation-reasons
// fails (network error, server error, etc.). Under normal operation the
// server returns the live taxonomy from the compiled-in @reasons constant in
// lib/fontawesome/baremetrics/cancellation_reasons.ex (refreshed via
// `mix fontawesome.baremetrics.sync_reasons` + deploy). Labels here SHOULD
// track that list, but drift isn't dangerous — fallback entries carry no
// `id` and are rejected by server validation anyway (see below).
//
// The fallback entries carry no `id` field — they are never sent to the
// server. If a customer submits with a fallback-only reason, the server's
// validate step rejects with 422 (reason_id not in @reasons), the customer
// sees the validation error, and they pick a different reason. Acceptable
// degraded mode for the rare case where Phoenix is up but
// /api/cancellation-reasons is failing.
export const FALLBACK_REASONS = [
  { label: 'I only needed it for a short-term project', requires_comment: false },
  { label: "Too expensive for what I'm getting", requires_comment: false },
  { label: 'I switched to another icon library', requires_comment: false },
  { label: 'FA was missing icons or features I needed', requires_comment: false },
  { label: 'FA Free is enough for my needs', requires_comment: false },
  { label: 'I had technical issues using FA', requires_comment: false },
  { label: 'I need to cut costs/tighten financial belt', requires_comment: false },
  { label: 'Other', requires_comment: true }
]

// Labels whose comment field must be non-empty before the form can submit.
// Only "Other" — without a comment, "Other" is a count with no signal at all.
// The other reasons carry categorical information; their comments stay
// optional so customers with strong opinions self-select into commenting.
// Used as a fallback when the server-supplied requires_comment flag is
// missing (e.g., in degraded mode where the Vue fallback list is being used).
export const COMMENT_REQUIRED_LABELS = new Set(['Other'])

export const COMMENT_MAX_LENGTH = 1000
